export default __webpack_public_path__ + "static/media/heroRender1.eb1d25c2.png";